import constants from '../Constants';
const {
  GET_REPORTS,
  REPORTS_LOADING,
  LOGOUT
} = constants;

const INIT_STATE = {
  reports:{},
  reportsLoading: false,
  query: {},
};

const ReportReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REPORTS:
      const { data, query } = action.payload;
      return { 
            reports: data, 
            reportsLoading: false,
            query
        };

    case REPORTS_LOADING:
        return {
            ...state, reportsLoading: action.payload,
        };
    case LOGOUT:
        return INIT_STATE;
    default:
        return state;
    }
}

export default ReportReducer;


// WEBPACK FOOTER //
// ./src/Reducers/ReportReducer.js